<template>
  <div>
    <v-text-field
      v-if="withSearch"
      class="search-field mb-6 mt-5"
      prepend-icon="$sl-search"
      single-line
      hide-details
      :label="$t('application.search-label')"
      v-model="search"
    ></v-text-field>

    <template v-if="isDepartments">
      <MessageBox class="my-5" type="info" v-if="!isAdministrator"> 
        <p>{{ $t('company.department-wp-info') }} {{ getCurrentUserDepartments($route.params.id, isAdministrator, false, true) }}</p>
      </MessageBox>
      <v-tabs v-model="tab" :fixed-tabs="$vuetify.breakpoint.xsOnly" :centered="$vuetify.breakpoint.xsOnly">
        <v-tab key="1"> {{ $t('labels.all') }}</v-tab>
        <v-tab key="2">{{ $t('company.sections') }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="1">
          <WorkplacesListItems
            :flat="flat"
            :model="model"
            :icon="icon"
            :withSearch="withSearch"
            :withApprenticesQty="true"
            :withExplanation="withExplanation"
            :actionType="actionType"
            @item-clicked="wpClicked"
            :filteredWp="filteredWorkplaces"
            :isEditable="isEditable"
          ></WorkplacesListItems>
        </v-tab-item>
        <v-tab-item key="2">
          <WorkplacesDepartments
            :flat="flat"
            :model="model"
            :icon="icon"
            :withSearch="withSearch"
            :withExplanation="withExplanation"
            :withApprenticesQty="true"
            :actionType="actionType"
            @item-clicked="wpClicked"
            :filteredWp="filteredWorkplacesDepartments"
          ></WorkplacesDepartments>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-else>
      <WorkplacesListItems
        :flat="flat"
        :model="model"
        :icon="icon"
        :withSearch="withSearch"
        :withExplanation="withExplanation"
        :actionType="actionType"
        @item-clicked="wpClicked"
        :filteredWp="filteredWorkplaces"
        :isEditable="isEditable"
      ></WorkplacesListItems>
    </template>
  </div>
</template>

<script>
import WorkplacesListItems from '@/components/Common/Workplace/WorkplacesListItems'
import WorkplacesDepartments from '@/components/Common/Workplace/WorkplacesDepartments'
import groupBy from 'lodash/groupBy'
import filter from 'lodash/filter'
import {CompanyRoles} from '@/components/mixins'
import {mapGetters} from 'vuex'
import MessageBox from '@/components/Common/MessageBox.vue'
import {forEach} from 'lodash'

export default {
  name: 'WorkplacesList',

  mixins: [CompanyRoles],

  components: {
    WorkplacesListItems,
    WorkplacesDepartments,
    MessageBox
  },
  props: {
    isDepartments: {
      type: Boolean,
      required: false,
      default: false
    },
    tabId: {
      type: Number,
      default: 0
    },
    workplaces: {
      type: Array,
      required: true
    },
    isEditable: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    },
    actionType: {
      type: String,
      required: false
    },
    searchText: {
      type: String,
      required: false
    },
    withSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    withExplanation: {
      type: Boolean,
      required: false,
      default: false
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false
    },
    model: {
      type: [Array, Number],
      required: false
    }
  },
  //emits: ['item-click'],
  data: function () {
    return {
      search: '',
      workplace: this.model,
      tab: null
    }
  },
  watch: {
    tabId: {
      handler: function () {
        this.tab = this.tabId
      },
      deep: true
    },

    model() {
      this.workplace = this.model
    }
  },
  created() {
    if (this.tabId && this.tabId > 0) {
      this.tab = this.tabId
    }
    if (this.searchText) {
      this.search = this.searchText
    }
  },
  methods: {
    wpClicked(item) {
      this.$emit('item-click', item)
    }
  },
  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isAdministrator']),

    filteredWorkplaces() {
      if (!this.search || !this.workplaces) return this.workplaces
      const fieldsToSearch = ['name', 'postalAddress1', 'postalCity', 'postalZip']
      return this.workplaces.filter(item =>
        fieldsToSearch.some(field => item[field] && item[field].toLowerCase().includes(this.search.toLowerCase()))
      )
    },

    filteredWorkplacesDepartments() {
      let deps = []
      let ret = []
      
      this.workplaces.forEach(wp => {
        wp.departmentWorkplaces.forEach(dw => {
          let findDep = -1
          if (this.getCurrentUserDepartmentsIds(this.$route.params.id, this.isAdministrator, false, true).length > 0) {
            findDep = this.getCurrentUserDepartmentsIds(this.$route.params.id, this.isAdministrator, false, true).find(x => x == dw.departmentId)
          }
          if (findDep > -1 || this.isAdministrator == true) {
            deps.push({
              id: wp.id,
              depName: dw.department.name,
              name: wp.name,
              postalAddress1: wp.postalAddress1,
              postalZip: wp.postalZip,
              postalCity: wp.postalCity,
              isInvoiceWorkplace: wp.isInvoiceWorkplace,
              isDeliveryWorkplace: wp.isDeliveryWorkplace,
              numApprenticeships: wp.numApprenticeships,
              tab: 1
            })
          }
        })
      })

      if (!this.search) {
        ret = groupBy(deps, function (o) {
          return o.depName
        })
        return ret
      }
      const fieldsToSearch = ['depName', 'name', 'postalAddress1', 'postalCity', 'postalZip']

      deps = deps.filter(item =>
        fieldsToSearch.some(field => item[field] && item[field].toLowerCase().includes(this.search.toLowerCase()))
      )

      return groupBy(deps, function (o) {
        return o.depName
      })

      // ret.map(function (key, value) {
      //   //list.push(key);
      //   this.departmentNames = key
      // })

      //ret=Object.values(ret)
      return ret      
    },

    actionIcon() {
      switch (this.actionType) {
        case 'view':
          return '$sl-arrow-right'
        case 'unlink':
          return '$sl-unlink'
        case 'checkbox':
        case 'select':
        default:
          return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.workplace-icons {
  transform: scale(0.75);
  margin: 0;
  display: flex;
}
</style>
